import Modal from "./modal";

export default class ImportStakeholdersModal extends Modal {
  constructor(companyId) {
    super("stakeholders-import-modal");
    this.companyId = companyId;
    this.$dropContainer = this.$modal._element.querySelector(".drop-container");
    this.$outputContainer = this.$modal._element.querySelector(
      "#import-output-container"
    );
    this.$output = this.$outputContainer.querySelector("textarea");

    this.$input = this.$modal._element.querySelector("input");
    this.setupListeners();
  }

  setupListeners() {
    this.$dropContainer.addEventListener("click", () => {
      this.$input.click();
    });
    this.$dropContainer.addEventListener("dragover", (e) => {
      e.preventDefault();
    });

    document.body.addEventListener(
      "trial-enabled",
      (e) => {
        this.$input.value = "";
      },
      false
    );

    this.$dropContainer.addEventListener("drop", (e) => {
      e.preventDefault();
      if (e.dataTransfer.items) {
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          if (e.dataTransfer.items[i].kind === "file") {
            let file = e.dataTransfer.items[i].getAsFile();
            this.uploadFile(file);
          }
        }
      } else {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          this.uploadFile(e.dataTransfer.files[i]);
        }
      }
    });

    this.$input.addEventListener("change", () => {
      this.uploadFiles();
    });
  }

  uploadFiles() {
    [...this.$input.files].forEach((file) => {
      this.uploadFile(file);
    });
  }

  uploadFile(file) {
    this.$output.innerText = "Uploading & parsing... Please wait";
    this.$outputContainer.classList.remove("d-none");
    const formData = new FormData();
    formData.append("company", this.companyId);
    formData.append("document", file);

    peque
      .api("stakeholders", formData, "post")
      .then((response) => {
        this.$input.value = "";

        if (response.error > 0) {
          peque.navigation.showError(response.result);
          return;
        }

        location.reload();
      })
      .catch((error) => {
        this.$input.value = "";

        if (error.error === peque.ERROR_UPGRADE_PLAN) {
          peque.showLimitReachedModal("stakeholder-limit");
          return;
        }

        this.$output.innerHTML =
          typeof error.result === "object"
            ? error.result.join("\n\n")
            : error.result;
      });
  }
}
